import { Api } from '@/services/Api'

const lib = {}

lib.getEpicGpsTime = (plantId) => {
  return Api().get(`/api/v1.0/iot/gps/time/${plantId}`)
}

export default lib
